'use client';

import clsx from 'clsx';
import { ThirdPartSelectors } from '@headless-workspace/config';
import { GlowImage } from '@headless-workspace/glow-ds';
import { ObjectHelpers } from '@headless-workspace/utils';
import { createPortal } from 'react-dom';
import { useIsClient } from 'usehooks-ts';

const IMAGE_HEIGHT = 80;
const IMAGE_WIDTH = 40;

const MarketingVideoLibraryLoader = () => {
    const isClient = useIsClient();

    if (!isClient) {
        return null;
    }

    return createPortal(
        <div
            className={clsx(
                ThirdPartSelectors.MarketingVideoLibraryLoaderClass,
                'inset-0 w-0 h-0 bg-background-overlay fixed z-[20] flex justify-center items-center select-none',
            )}
        >
            <GlowImage
                id={ThirdPartSelectors.MarketingVideoLibraryLoaderSvgId}
                className={'h-[5rem] hidden'}
                image={ObjectHelpers.createImageWithSrc('/images/loaderSephora.svg')}
                height={IMAGE_HEIGHT}
                width={IMAGE_WIDTH}
            />
        </div>,
        document.body,
    );
};

export default MarketingVideoLibraryLoader;
